<template>
  <div class="signBox">
    <!--头部-->
    <XDheader></XDheader>
     <div class="container">
       <img src="https://scdn.xidong360.com/longhu-marathon/2019/0816/menu/banner.png" alt="">
      <h5>当前的位置是立即报名</h5>
      <!--内容-->
      <div class="row">
            <div class="col-md-8" >
              <div class="content_title" >
                <span class="themes_menu_wrap_1">立即报名</span>
              </div>
              <form id="signform" v-show="show">
                <div class="signform">
                  <h6 class="title"><em><img src="https://scdn.xidong360.com/longhu-marathon/2019/0816/sign_project.svg" alt="" style="width:20px;">项目信息／Project
                      information
                    </em>
                  </h6>
                  <!-- 参赛项目 -->
                  <ul class="form">
                    <li class="col-xs-12" style="margin-bottom:0;height:35px;">
                      <div class="radio-form">
                        <label style="margin-right: 15px;" @click="active(item.id)" class="halfRadio" :class="signform.id==item.id?'active':''" v-for="(item,i) in project" :key="i">
                          <input type="radio"  name="groupId" :value="item.id">{{item.name}}
                        </label>
                      </div>
                      <i class="error txtEmergencyContact" style="display: none;">参赛项目不能为空</i>
                    </li>
                  </ul>
                  <h6 class="title">
                    <em><img src="https://scdn.xidong360.com/longhu-marathon/2019/0816/sign_person.jpg" alt="">个人信息／Personal information</em>
                  </h6>
                  <ul class="form form-icon">
                    <li class="col-xs-3"><em>手机号／Mobile Number：</em>
                      <input id="textMobile" type="text" name="phone" v-model="signform.phone" placeholder="输入您的手机号" />
                      <i class="error textMobile" style="display: none;">手机号不能为空</i>
                    </li>
                    <li class="col-xs-3"><em>证件类型／ID Type：</em>
                      <div class="dropdown blue-dropdown">
                        <button class="btn btn-primary dropdown-toggle"   type="button" data-toggle="dropdown" id="IDvalue">
                          <i>请选择证件类型</i>
                          <span class="caret"></span>
                          <input type="hidden" id="txtIdType" name="certificateType">
                        </button>
                        <ul class="dropdown-menu">
                          <li v-for="(item,i) in IDtype" :key="i"><a href="javascript:void(0);" :data-value="item">{{item}}</a></li>
                        </ul>
                      </div>
                      <i class="error txtIdType" style="display: none;">证件类型不能为空</i>
                    </li>
                    <li class="col-xs-6"><em>证件号码／ID Number：</em>
                      <input type="text" id="txtIdCard" name="certificate" v-model="signform.IDnumber" placeholder="输入有效证件号码">
                      <i class="error txtIdCard" style="display: none;">证件号不能为空</i>
                    </li>
                    <li class="col-xs-12" style="height: 0;border-bottom: 1px solid #dbe5ea;"></li>
                    <li class="col-xs-4"><em>姓 名／Name：</em>
                      <input id="txtUserName" type="text" name="name" v-model="signform.name" placeholder="输入您的真实姓名">
                      <i class="error txtUserName" style="display: none;">姓名不能为空</i>
                    </li>
                    <li class="col-xs-4"><em>性 别／Sex：</em>
                      <div class="radio-form">
                        <label style="margin-right: 15px;" class="manRadio" :class="signform.sex=='男'?'active':''">
                          <input type="radio"  @click="active1('男')" name="sex" id="sexM" value="男">男/M
                        </label>
                        <label style="margin-right: 0;" class="womenRadio"  :class="signform.sex=='女'?'active':''">
                          <input type="radio" name="sex"  @click="active1('女')" id="sexF" value="女">女/F
                        </label>
                      </div>
                      <i class="error txtSex" style="display: none;">性别不能为空</i>
                    </li>
                    <li class="col-xs-4"><em>出生日期／Birthday：</em>
                      <div class="form-group ">
                        <div class="input-group date">
                        <el-date-picker type="date" placeholder="选择出生日期" style="width:145px;" v-model="signform.value1"></el-date-picker>
                        <span class="input-group-addon" style="width:40px;">
                            <span class="glyphicon glyphicon-calendar"></span>
                        </span>
                          <!-- <input type="date"  v-model="value1" class="form-control form_datetime" id="birthday" name="birthday"
                            placeholder="选择出生日期" readonly="" style="background-color: #fff;cursor: pointer;"> -->
                         
                        </div>
                      </div>
                      <i class="error form_datetime" style="display: none;">出生日期不能为空</i>
                    </li>
                    <li class="col-xs-3"><em>血 型／Blood：</em>
                      <div class="dropdown blue-dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" id="bloodvalue">
                          <i id="txtBloodMessage">请选择血型</i>
                          <span class="caret"></span>
                          <input type="hidden" id="txtBlood" name="bloodtype">
                        </button>
                        <ul class="dropdown-menu" id="dropdown-menu">
                          <li v-for="(item,i) in bloodtype" :key="i"><a href="javascript:void(0);" :data-value="item">{{item}}</a></li>
                        </ul> 
                      </div>
                      <i class="error txtBlood" style="display: none;">血型不能为空</i>
                    </li>
                    <li class="col-xs-4"><em>衣服尺码／Clothes Size：</em>
                      <div class="dropdown blue-dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" id="sizevalue">
                          <i id="txtClothesSizeMessage">请选择衣服尺码</i>
                          <span class="caret"></span>
                          <input type="hidden" id="txtClothesSize" name="clothes_size">
                        </button>
                        <ul class="dropdown-menu">
                          <li v-for="(item,i) in size" :key="i"><a href="javascript:void(0);" :data-value="item">{{item}}</a></li>
                        </ul>
                      </div>
                      <i class="error txtClothesSize" style="display: none;">衣服尺码不能为空</i>
                    </li>
                    <li class="col-xs-5"><em>国家及地区／Nationality and Area：</em>
                      <div class="dropdown blue-dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" id="countryvalue">
                          <i id="txtCountryMessage">选择国家及地区</i>
                          <span class="caret"></span>
                          <input type="hidden" id="txtCountry" name="country">
                        </button>
                        <ul class="dropdown-menu">
                          <li  v-for="(item,i) in country" :key="i"><a href="javascript:void(0);" :data-value="item">{{item}}</a></li> 
                        </ul>
                      </div>
                      <i class="error txtCountry" style="display: none;">国家不能为空</i>
                    </li>
                    <li class="col-xs-4"><em>邮 箱／Email：</em>
                      <input id="txtEmail" type="text" name="email" v-model="signform.email"  placeholder="输入您的真实邮箱">
                      <i class="error txtEmail" style="display: none;">邮箱不能为空</i>
                    </li>
                    <li class="col-xs-8"><em>联系地址／Address：</em>
                      <input id="txtAddress" type="text" name="address" v-model="signform.address" placeholder="输入您的联系地址">
                      <i class="error txtAddress" style="display: none;">联系地址不能为空</i>
                    </li>
                  </ul>
                  <h6 class="title">
                    <em><img src="https://scdn.xidong360.com/longhu-marathon/2019/0816/sign_contact.jpg" alt="">紧急联系人／Emergency Contact Information</em>
                  </h6>
                  <ul class="form">
                    <li class="col-xs-4"><em>紧急联系人姓名／Name：</em>
                      <input id="txtEmergencyContact" type="text" name="emergencyContact" v-model="signform.contacts" placeholder="输入紧急联系人的姓名">
                      <i class="error txtEmergencyContact" style="display: none;">紧急联系人不能为空</i>
                    </li>
                    <li class="col-xs-4"><em>紧急联系人电话／Mobile：</em>
                      <input id="txtEmergencyPhone" type="text" name="emergencyContactPhone" v-model="signform.contactNumber" placeholder="contactNumber">
                      <i class="error txtEmergencyPhone" style="display: none;">紧急联系人手机不能为空</i>
                    </li>
                    <li class="col-xs-4"><em>与参赛者关系／Relation：</em>
                      <input id="txtRelation" type="text" name="relationshipwithplayer" v-model="signform.relation"  placeholder="输入与参赛者关系">
                      <i class="error txtRelation" style="display: none;">与参赛者关系不能为空</i>
                    </li>
                  </ul>
                  <h6 class="title">
                    <em>其他信息／Other Information</em>
                  </h6>
                  <ul class="form">
                    <li class="col-xs-6"><em>是否郑州籍／Zhengzhou：</em>
                      <div class="dropdown blue-dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" id="nactive">
                          <i id="txtzhengzhounativeMessage">请选择是否郑州籍</i>
                          <span class="caret"></span>
                          <input type="hidden" id="txtzhengzhounative" name="zhengzhounative">
                        </button>
                        <ul class="dropdown-menu">
                          <li><a href="javascript:void(0);" data-value="是">是</a></li>
                          <li><a href="javascript:void(0);" data-value="否">否</a></li>
                        </ul>
                      </div>
                      <i class="error txtzhengzhounative" style="display: none;">是否郑州籍不能为空</i>
                    </li>
                    <li class="col-xs-6"><em>是否需要车辆接驳／Take shuttle bus：</em>
                      <div class="dropdown blue-dropdown">
                        <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" id="deliver">
                          <i id="txtneedtransferMessage">请选择是否需要车辆接驳</i>
                          <span class="caret"></span>
                          <input type="hidden" id="txtneedtransfer" name="needtransfer">
                        </button>
                        <ul class="dropdown-menu">
                          <li><a href="javascript:void(0);" data-value="不需要">不需要</a></li>
                          <li><a href="javascript:void(0);" data-value="紫荆山地铁站">紫荆山地铁站</a></li>
                          <li><a href="javascript:void(0);" data-value="柳林地铁站">柳林地铁站</a></li>
                          <li><a href="javascript:void(0);" data-value="众意西路地铁站">众意西路地铁站</a></li>
                        </ul>
                      </div>
                      <i class="error txtneedtransfer" style="display: none;">是否需要车辆接驳不能为空</i>
                    </li>
                  </ul>
                   <p class="next-step clearfix" style="padding-top: 15px;">
                      <a class="right" id="nextStep"  @click="checked()" href="javascript:void(0)">提交报名</a>
        
                  </p>
                </div>
              </form>
            <div class="commitment" v-show="!show" style="padding-left: 0;">
                <h6 class="title">参赛免责声明</h6>
                <div class="content" v-for="(item,i) in commitment" :key="i" style="font-size:12px;">
                  <p>
                    <strong>{{item[0]}}</strong>
                  </p>
                  <p v-for="(item,i) in item[1]" :key="i">
                      {{item}}
                  </p>
                </div>
                <div class="agreen checkbox">
                  <label style="font-weight: 600;">
                    <input type="checkbox" @click="nextstep()" id="chkConfirm">本人已认真阅读并全面理解本免责声明内容，且对上述所有内容予以确认并承担相应的法律责任！ I agree the
                    statement
                    above!
                  </label>
                </div>
                 <p class="next-step clearfix" style="padding-top: 15px;">
                      <a class="right" id="nextStep"  v-show="next" @click="show=true" href="javascript:void(0)">下一步/Next</a>
                         <a class="right unclick" v-show="!next" href="javascript:void(0)">下一步/Next</a>
                  </p>
               
              </div>
            </div>
            <div class="col-md-4">
               <XDright></XDright>
            </div>
      </div>
    
    </div>
    <!--底部-->
    <XDfooter></XDfooter>
  </div>
</template>
<script>
import api from "@/axios";
import { mapState, mapGetters } from "vuex";
export default {
  name: "sign",
  data() {
    return {
      project : [
          {
            id:'mWcGY3uqNJuAkJBqk',
            name:'半程马拉松'
          },
          {
            id:'uXbymJdwmuuEymxPo',
            name:'迷你跑（约5千米）'
          },
          {
            id:'ytpJLZXtXRCPzJXM4',
            name:'Registration 21.0975KM (外籍)'
          },

      ],
      signform:{
          id:'',
          phone:'',
          IDvalue:'',
          IDnumber:'',
          name:'',
          sex:'',
          value1: '',
          bloodvalue:'',
          sizevalue:'',
          countryvalue:'',
          email:'',
          address:'',
          contacts:'',
          contactNumber:'',
          relation:'',
          nactive:'',
          deliver:''   
      },
      show:false,
      next:false,
      IDtype:['居民身份证','护照','港澳通行证','台胞证','军人证','回乡证','其他证件'],
      bloodtype:['A','B','AB','O'],
      size:['XS','S','M','L','XL','XXL','XXXL','XXXXL'],
      country:['中国','Afghanistan','Albania','Algeria','American Samoa','Andorra','Angola','Anguilla','Antarctica','Antigua and Barbuda','Argentina','Armenia',
                'Aruba','Ascension Island','Australia','Austria','Azerbaijan','Bahamas','Bahrain','Bangladesh','Barbados','Belgium','Belize','Benin','Bermuda',
                'Bhutan','Bolivia','Bosnia and Herzegovina','Botswana','Bouvet Island','Brazil','British Indian Ocean Territory','Brunei','Bulgaria',
                'Burkina Faso','Burundi','Cambodia','Aland lslands','Cameroon','Canada','Cape Verde','Cayman Islands','Central African Republic','Chad','Chile',
                'Christmas Island','Cocos(Keeling)Islands','Colombia','Comoros','Congo','Congo(DRC)','Cook Islands',"Costa Rica","Cote d'Ivoire","Croatia","Cuba",
                "Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Eritrea","Estonia","Ethiopia",
                "Falkland Islands","Faroe Islands","Fiji Islands","Finland","France","Frech Polynesia","French Guiana","French Southern and Antarctic Lands","Gabon",
                "Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guadeloupe","Guam","Guatemala","Guernsey","Guinea","Guinea-Bissau",
                "Guyana","Haiti","Heard Island and McDonald Islands","Honduras","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel",
                "Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kiribati","Korea","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia",
                "Libya","Liechtenstein","Lithuania","Luxembourg","Former Yugoslav Republic of Macedonia","Malawi","Malaysia","Madagascar","Maldives","Mali","Malta",
                "Marshall Islands","Martinique","Mauritania","Mauritius","Mayotte","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montserrat","Morocco","Mozambique",
                "Myanmar","Namibia","Nauru","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Niue","Norfolk Island",
                "Northern Mariana Islands","North Korea","Norway","Oman","Pakistan","Palau","Palestinian Authority","Panama","Papua New Guinea","Paraguay","Peru","Philippines",
                "Pitcairn Islands","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia",
                "Senegal","Serbia,Montenegro","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia","South Africa","South Georgia and South Sandwich Islands",
                "Spain","Sri Lanka","St.Helena","St.Kitts and Nevis","St.Lucia","St.Pierre and Miquelon","St.Vincent and the Grenadines","Sudan","Suriname","Svalbard and Jan Mayen",
                "Swaziland","Sweden","Switzerland","Syria","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tokelau","Tonga","Trinidad and Tobago","Tristan da Cunha","Tunisia",
                "Turkey","Turkmenistan","Turks and Caicos Islands","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","United States Minor Outlying Islands",
                "Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Virgin Islands","Virgin Islands,British","Wallis and Futuna","White Russia","Yemen","Zambia",
                "Zimbabwe","Other"
      ],
      commitment:[ 
          ["一、参赛选手声明",
            [
                "作为参赛选手，我本人、我的监护人、管理人、法定代理人以及任何可能代表我提起赔偿请求或诉讼的人做出以下声明：",
                "1.本人自愿参加本次赛事及赛事相关的一切活动，我确认本人具有参加本赛事相应的民事行为能力和民事责任能力,并且已获得监护人的同意；",
                "2.本人确认全面理解并同意遵守赛事组委会及协办机构所制定的各项规程、规则、规定、要求及采取的措施；",
                "3.本人必须提供真实有效的个人信息，代替他人报名须对报名选手的个人信息负责，并确保报名选手本人知悉本免责声明各项条款；",
                "4.本人承诺以本人名义参赛，知悉获得的参赛资格及号码布和计时芯片在内的竞赛物品不以任何方式转让给他人；",
                "5.本人承诺在比赛过程中服从裁判和赛事工作人员的管理和指挥；",
                "6.本人知悉参加此项比赛对健康状况有特殊要求以及存在的不安全因素，同时对参赛可能存在的各种风险和意外已做出审慎的评估，这些风险包括但不限于：交通事故；天气改变或自然灾害等引发的风险；湿热带来的危险，包括中暑等；自身身体状况，或伴随着活动本身的生理反应可能引发的风险；动物或昆虫可能对人体造成的侵害；其他可能面临的危险或意外和事故等。本人愿意承担比赛期间发生的自身意外风险责任，且同意组办方对于非组委会原因造成的伤害、死亡或其他任何形式的损失不承担任何形式的赔偿；"
              , "7.本人已为参赛做好充分训练和准备并经国家认证的医疗机构体检，确认自身身体和精神健康状况符合参赛的各项要求；",
                "8.本人同意接受组委会在比赛期间本人发生意外情况下提供的现场急救性质的医务治疗，发生的一切医疗费用或住院费用等超出赛事保险赔付标准部分均由本人承担；",
                "9.本人同意在活动中若本人丧失意识，组委会的急救志愿者可采取一切手段进行急救，包括但不限于CPR心肺复苏，AED体外除颤，租用车辆或航空器进行快速转运。由此产生的法律责任以及伴随的费用，均由参赛选手承担，概不追究组办方和参与施救的急救志愿者任何法律和经济方面的责任；",
                "10.本人同意在活动中若发生任何风险，包括但不限于伤痛、身体损害、不可逆转的永久性身体损伤、后遗症、意外、责任以及事件伴随的经济损失，均由本人自己承担，与组委会无关；",
                "11.本人同意如因隐瞒身体健康情况，在比赛期间发生的人身伤害、局部或永久性伤残、死亡、医疗或住院费用，由本人承担全部责任或费用，免除赛事组委会全部责任，组办方对此不承担任何形式的赔偿；",
                "12.本人同意参加比赛有关的所有照片、图片、影片、录像片和影音片，永远归比赛组织单位所有，并同意赛事组委会或指定媒体及赞助商无偿使用或授权使用前述资料；",
                "13.本人承诺永久授权赛事组委会及其继承或受让单位使用本人于比赛的除证件号码和联系方式以外的个人信息、肖像、声音和外貌，其使用包括并不限于任何市场活动、任何商业用途、任何媒体、任何成品及其相关广告品；",
                "14.本人愿意接收赛事组委会（包括赞助商）发布的相关赛事信息；",
                "15.本人同意通过赛事组委会官方网站自助打印获取半程马拉松赛完赛成绩证书；",
                "16.本人同意赛事组委会以我为被保险人投保人身意外险（含猝死）；",""              
              ]
          ],
          ["二、参赛者身体状况要求",
            [
                "马拉松是一项高负荷、大强度、长距离的竞技运动，也是一项高风险的竞技项目，对参赛者身体状况有较高的要求。参赛者应身体健康，有长期参加跑步锻炼的基础。有以下身体状况者不宜参加比赛：",
                "1.先天性心脏病和风湿性心脏病；",
                "2.高血压和脑血管疾病；",
                "3.心肌炎和其他心脏病；",
                "4.冠状动脉病和严重心律不齐；",
                "5.血糖过高或过低的糖尿病；",
                "6.比赛日前两周以内患感冒；",
                "7.妊娠；",
                "8.其它不适合运动的疾病。",
                "组委会要求每位参赛选手在赛前要到县级以上医院进行一次身体检查，检查结论为身体健康者方能参加比赛。否则，因个人身体及其他个人原因导致的人身损害和财产损失，由参赛选手本人承担责任。"
            ]
          ],
          ["三、组委会取消参赛资格或比赛成绩的行为范畴",
            [
                " 若发现任何如下违规行为，参赛者将被立即取消参赛资格，取消参赛成绩或证书，并且赛事组委会保留禁止参赛者参加今后本赛事的权利。",
                "1.虚假年龄报名或报名后由他人替跑；",
                "2.参赛者携带他人计时芯片或一名选手同时携带2枚或两枚以上(包括男选手携带女选手)计时芯片参加比赛；",
                "3.不按规定的起跑顺序在非指定区域起跑；",
                "4.起跑有违反规则行为；",
                "5.关门时间到后不停止比赛或退出比赛后又返回赛道；",
                "6.没有沿规定线路跑完所报项目的全程，抄近道或乘交通工具途中插入；",
                "7.以接力方式完成比赛；",
                "8.不按规定要求重复通过终点、未跑完全程私自通过终点领取完赛纪念品；",
                "9.私自伪造号码布，使用其他赛事号码布，或未佩戴号码布和本次比赛芯片通过终点领取完赛纪念品；",
                "10.私自涂改、遮挡号码布参赛或转让号码布；",
                "11.出现不文明行为，不服从赛事工作人员的指挥，干扰赛事，打架斗殴，聚众闹事；",
                "12.其他违反规则规定的行为。"
            ]
          ],
          ["四、报名参赛跑友可获得的物品",
            [
                "1.报名并缴费的半程马拉松跑友可获得参赛服装、号码布、计时芯片、参赛包、完赛奖牌（完赛选手可获得）、现场补给、保险。",
                "2.报名并缴费的迷你马拉松跑友可获得参赛服装、号码布、保险。",
                "备注：以上获得参赛物品已实物为准。"

            ]
          ]
      ],


    };
  },
  mounted() {
      this.getOptions()  
  },
  watch: {
   
  },
  methods: {
    gotopath(path) {
      this.$router.push({ path });
    },
    active(i){
        this.signform.id=i;

    },
    active1(i){
         this.signform.sex=i;
    },
    getOptions(){
        $('.dropdown').click(function(){
            $(this).find('.dropdown-menu').toggleClass("active");
        })
        $('.dropdown-menu li').click(function(){
            $(this).parent().prev().find("i").text($(this).find('a').text())
         $(this).parent().find('ul').toggleClass("active")

        })
          
    },
    checked(){
        let IDvalue=$('#IDvalue i').text();
        let bloodvalue=$('#bloodvalue i').text();
        let sizevalue=$('#sizevalue i').text()
        let countryvalue=$('#countryvalue i').text();
        let nactive=$('#nactive i').text();
        let deliver=$('#deliver i').text();
      this.signform.IDvalue=IDvalue=='请选择证件类型'?'':IDvalue;
      this.signform.bloodvalue=bloodvalue=='请选择血型'?'':bloodvalue;
      this.signform.sizevalue=sizevalue=='请选择衣服尺码'?'':sizevalue;
      this.signform.countryvalue=countryvalue=='选择国家及地区'?'':countryvalue;
      this.signform.nactive=nactive=='请选择是否郑州籍'?'':nactive;
      this.signform.deliver=deliver=='请选择是否需要车辆接驳'?'':deliver;
      
        
        for( var i in this.signform){
            if(!this.signform[i]){
                this.open()
            }     
        }
    },
    open(){
         this.$confirm('检测到当前您有未填写的信息，是否填写信息以继续报名？', '是否继续进行报名', {
          distinguishCancelAndClose: true,
          confirmButtonText: '继续报名',
          cancelButtonText: '放弃报名'
        })
          .then(() => {
            this.$message({
              type: 'info',
              message: '请输入您未填写的信息'
            });
          })
          .catch(action => {
            this.$message({
              type: 'info',
              message: action === 'cancel'
                ? '您已放弃此次报名'
                : '停留在当前页面'
            })
          });


    },
    nextstep(){
        this.next=true;
    },
  },
  computed: {
    ...mapState(["gameId"])
  }
};
</script>
<style scoped>
@import "../../assets/themes/sign.css";
.active{
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/template/sign/sign.vue